import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const CollabDraftWithRelevanceQuery: GraphQLTaggedNode = graphql`
	query CollabDraftWithRelevanceQuery($id: ID!, $draftShareId: String = "", $hydrateAdf: Boolean) {
		collabDraft(id: $id, draftShareId: $draftShareId, hydrateAdf: $hydrateAdf) {
			document
			version
			metadata {
				title
				relevance
			}
		}
	}
`;
